export default "__VITE_ASSET__BHjEIa5m__"